/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { SocialExportPromoteUploadMutationResponse, SocialExportPromoteUploadPathParams, SocialExportPromoteUpload400, SocialExportPromoteUpload401, SocialExportPromoteUpload403, SocialExportPromoteUpload404 } from "../models/SocialExportPromoteUpload";

export function getSocialExportPromoteUploadUrl(id: SocialExportPromoteUploadPathParams["id"]) {
  const res = { method: 'POST', url: `/social-export/v1/upload/${id}/promote` as const }
  return res
}

/**
 * @description Promotes a scheduled upload to the front of the queue so it publishes immediately.
 * @summary Immediately publish a scheduled upload
 * {@link /social-export/v1/upload/:id/promote}
 */
export async function socialExportPromoteUpload(id: SocialExportPromoteUploadPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<SocialExportPromoteUploadMutationResponse, ResponseErrorConfig<SocialExportPromoteUpload400 | SocialExportPromoteUpload401 | SocialExportPromoteUpload403 | SocialExportPromoteUpload404>, unknown>({ method : "POST", url : getSocialExportPromoteUploadUrl(id).url.toString(), ... requestConfig })
  return res.data
}